// @aiContributed-MAPFuse-2026-01-16
/* istanbul ignore file */
/* eslint-disable */
/**
 * Polyfill for Promise.prototype.bind() method
 * Some legacy code expects this method which was present in Bluebird promises
 * but not in native ES6 promises. This polyfill implements Bluebird-like behavior
 * where .bind() sets the context for all subsequent promise handlers in the chain.
 */

if (typeof Promise !== 'undefined' && !Promise.prototype.bind) {
  /**
   * Returns a promise where all subsequent .then(), .catch(), and .finally() handlers
   * will be called with the specified context as 'this'.
   * This mimics Bluebird's Promise.bind() behavior.
   * @param {*} context - The context to bind to subsequent promise handlers
   * @returns {Promise} A new promise with bound context for subsequent handlers
   */
  Promise.prototype.bind = function(context) {
    const originalPromise = this;

    // Create a bound promise that wraps the original
    const boundPromise = originalPromise.then(
      value => value,
      error => { throw error; }
    );

    // Store the context on the promise so subsequent handlers can access it
    boundPromise._boundContext = context;

    // Override then, catch, and finally to use the bound context
    const originalThen = boundPromise.then.bind(boundPromise);
    const originalCatch = boundPromise.catch.bind(boundPromise);
    const originalFinally = boundPromise.finally.bind(boundPromise);

    boundPromise.then = function(onFulfilled, onRejected) {
      const ctx = this._boundContext;
      const wrappedOnFulfilled = onFulfilled && typeof onFulfilled === 'function'
        ? function(value) { return onFulfilled.call(ctx, value); }
        : onFulfilled;
      const wrappedOnRejected = onRejected && typeof onRejected === 'function'
        ? function(error) { return onRejected.call(ctx, error); }
        : onRejected;

      const newPromise = originalThen(wrappedOnFulfilled, wrappedOnRejected);
      // Propagate the bound context to the new promise
      if (ctx) {
        newPromise._boundContext = ctx;
        newPromise.then = boundPromise.then;
        newPromise.catch = boundPromise.catch;
        newPromise.finally = boundPromise.finally;
      }
      return newPromise;
    };

    boundPromise.catch = function(onRejected) {
      const ctx = this._boundContext;
      const wrappedOnRejected = onRejected && typeof onRejected === 'function'
        ? function(error) { return onRejected.call(ctx, error); }
        : onRejected;

      const newPromise = originalCatch(wrappedOnRejected);
      // Propagate the bound context to the new promise
      if (ctx) {
        newPromise._boundContext = ctx;
        newPromise.then = boundPromise.then;
        newPromise.catch = boundPromise.catch;
        newPromise.finally = boundPromise.finally;
      }
      return newPromise;
    };

    boundPromise.finally = function(onFinally) {
      const ctx = this._boundContext;
      const wrappedOnFinally = onFinally && typeof onFinally === 'function'
        ? function() { return onFinally.call(ctx); }
        : onFinally;

      const newPromise = originalFinally(wrappedOnFinally);
      // Propagate the bound context to the new promise
      if (ctx) {
        newPromise._boundContext = ctx;
        newPromise.then = boundPromise.then;
        newPromise.catch = boundPromise.catch;
        newPromise.finally = boundPromise.finally;
      }
      return newPromise;
    };

    return boundPromise;
  };
}
